'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CSS = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CSS = exports.CSS = function CSS(_ref) {
  var css = _ref.css;
  return _react2.default.createElement('style', {
    dangerouslySetInnerHTML: {
      __html: css
    }
  });
};

CSS.defaultProps = {
  css: '*{box-sizing:border-box}body{margin:0}'
};

CSS.displayName = 'CSS';

exports.default = CSS;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/CSS.js
// module id = 217
// module chunks = 35783957827783 162898551421021